var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#3D3D3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9585 3.2912C12.1688 3.12768 12.4726 3.1424 12.6658 3.33561C12.875 3.54482 12.875 3.88402 12.6658 4.09322L8.75883 8.00013L12.6658 11.907C12.875 12.1162 12.875 12.4554 12.6658 12.6647C12.4726 12.8579 12.1688 12.8726 11.9585 12.7091L11.9541 12.7056L11.9121 12.6686L8.0012 8.75775L4.09031 12.6686L4.04833 12.7056L4.04392 12.7091C3.83362 12.8726 3.52981 12.8579 3.3366 12.6647C3.12738 12.4554 3.12738 12.1162 3.3366 11.907L7.24357 8.00013L3.3366 4.09322C3.12738 3.88402 3.12738 3.54482 3.3366 3.33561C3.52981 3.1424 3.83362 3.12768 4.04392 3.2912L4.04833 3.29462L4.09031 3.33169L8.0012 7.24252L11.9121 3.33169L11.9541 3.29462L11.9585 3.2912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.23086d6c29380789e14d6b22310e6e2d.svg";
export { ForwardRef as ReactComponent };